import { z } from 'zod';

/**
 * Whether publishing a version invalidates the consent members already gave
 * (N16, `03-legal-consent.md` §materiality).
 *
 * - `material` — the obligations changed. Every member must re-accept, so the
 *   publish emits `ConsentPublished` and the consent gate re-arms (M8).
 * - `minor` — a typo, a clarification, a broken link. The new version simply
 *   becomes current; nobody is asked again.
 *
 * It is chosen **at publish**, not at draft: staff only know what a change
 * amounts to once the text is final, and a draft that carried the choice would
 * invite setting it early and forgetting it.
 */
export const LEGAL_MATERIALITIES = ['material', 'minor'] as const;

export const LegalMaterialitySchema = z.enum(LEGAL_MATERIALITIES);

export type LegalMateriality = (typeof LEGAL_MATERIALITIES)[number];

/** Whether publishing at this materiality forces every member to consent again. */
export function forcesReconsent(materiality: LegalMateriality): boolean {
  return materiality === 'material';
}
